import { render, staticRenderFns } from "./payment-type-stripe.vue?vue&type=template&id=1c120206"
import script from "./payment-type-stripe.vue?vue&type=script&lang=js"
export * from "./payment-type-stripe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports